import styles from "../../../pages/superadmin/Receipts.module.css";
import { Close } from "../../icons/Icon";
import Button from "../Dealers/Button";

const Warning = ({ message, items, mode, handleCloseModal, orderdItems }) => {
  return (
    <div
      className={styles.warning}
      style={mode ? { backgroundColor: "#232529" } : {}}
    >
      <p style={mode ? { color: "#FFFFFF" } : {}}>{message}!</p>
      <ul className={styles.data_list}>
        <li
          style={{
            backgroundColor: mode ? "#2C2E33" : "",
            color: mode ? "#FFFFFF" : "#646B88",
            fontWeight: "600",
          }}
        >
          <div style={{ flex: "1" }}>Item No</div>
          <div style={{ flex: "1" }}>Warehouse</div>
          <div style={{ flex: "1" }}>Available Qty</div>
          <div style={{ flex: "1" }}>Ordered Qty</div>
        </li>
        <div className={styles.item_properties_scroll}>
          {items &&
            items?.map(({ itemNo, qty, warehouse }, index) => (
              <li
                style={{
                  backgroundColor: mode ? "#1B1D21" : "#FFFFFF",
                  color: mode && "#FFFFFF",
                }}
                key={index}
              >
                <div style={{ flex: "1" }}>{itemNo}</div>
                <div style={{ flex: "1" }}>{warehouse}</div>
                <div style={{ flex: "1" }}>{qty}</div>
                <div style={{ flex: "1" }}>
                  {
                    orderdItems?.find((ordered) => ordered.itemNo === itemNo)
                      ?.qty
                  }
                </div>
              </li>
            ))}
        </div>
      </ul>
      <div>
        <Button
          buttonIcon={<Close />}
          buttonText={"Close"}
          buttonBgColor={"#000000"}
          buttonTextColor={"#FFFFFF"}
          buttonClick={handleCloseModal}
        />
      </div>
    </div>
  );
};

export default Warning;
